import { initStore } from "@dariosoft/tools";

export const StoreManager = initStore();